export default {
  brandName: "Basetao Sheet",
  navHome: "Accueil",
  navGuide: "Guide Spreadsheet",
  navCategories: "Catégories",
  navFaq: "FAQ",
  navShoppingGuide: "Guide d'achat",
  articleNotFound: "Article introuvable",
  tocTitle: "Table des matières",
  backHome: "Retour à l'accueil",
  relatedTitle: "Ressources liées",
  authorName: "Équipe éditoriale Basetao Sheet",
  authorRole: "Recherche d'achat indépendante",
  articleFaqTitle: "Questions fréquentes",
  ctaBasetao: "Basetao Spreadsheet",
  ctaBuyNow: "Acheter",
  languageLabel: "Langue",
  footerTagline:
    "Un hub de ressources indépendant pour la recherche Basetao Spreadsheet, les catégories de produits, les guides et les conseils pratiques d'achat en Chine.",
  footerNavTitle: "Explorer",
  footerCategoriesTitle: "Catégories",
  footerLegalTitle: "Mentions légales",
  footerPrivacy: "Confidentialité",
  footerTerms: "Conditions",
  footerDisclaimer: "Avertissement",
  footerAbout: "À propos",
  footerContact: "Contact",
  footerDisclaimerText:
    "Ceci est un site d'information indépendant. Nous ne sommes ni affiliés à Basetao, ni le site officiel de Basetao. Toutes les marques appartiennent à leurs propriétaires respectifs. La disponibilité, les prix et les frais de livraison peuvent changer à tout moment.",
  footerCopyright: "Tous droits réservés.",
  footerMadeWith: "Ressource indépendante · Mise à jour régulière",
};